"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.TabPanel = exports.ScrollButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon/Icon");
var _propTypes = require("prop-types");
var _Tab = require("./Tab");
var _classnames = _interopRequireDefault(require("classnames"));
var _tabsModule = _interopRequireDefault(require("@albelli/arc-3/lib/tabs.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function debounce(func, ms) {
  let debounceTimer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      func(...args);
    }, ms);
  };
}
class Tabs extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "updateButtons", debounce(() => {
      //on resize on scroll buttons may need to appear or disappear
      if (this.tabsRef.current) {
        this.updateScrollButtonState(this.tabsRef.current.scrollLeft);
      }
    }, 166));
    _defineProperty(this, "handleScrollClick", (e, dir) => {
      const {
        scrollWidth
      } = this.state;
      const direction = dir === "left" ? -1 : 1;
      const tabList = this.tabsRef.current;
      const amount = tabList.offsetWidth / 3 * 2 * direction;
      const maxScroll = scrollWidth - this.tabsRef.current.offsetWidth;
      const minScroll = 0;
      const curScroll = tabList.scrollLeft;
      //if moving right, limit to max : if moving left, limit to min
      let newScroll = direction > 0 ? Math.min(curScroll + amount, maxScroll) : Math.max(curScroll + amount, minScroll);
      const tabs = tabList.children;
      //if we are going to bring the first or last tab into view then bring the entire tab into view
      if (direction < 0 && newScroll < tabs[0].offsetWidth) newScroll = 0;
      if (direction > 0 && newScroll > maxScroll - tabs[tabs.length - 1].offsetWidth) newScroll = maxScroll;
      this.scrollTo(newScroll);
    });
    _defineProperty(this, "setActiveTab", index => {
      var div = this.tabsRef.current.children[index];
      this.setState({
        animationStage: 2,
        selectedIndex: index,
        selectedLeft: div.offsetLeft,
        selectedWidth: div.offsetWidth,
        prevSelectedLeft: this.state.selectedLeft
      });
      this.scrollTo(this.calculateScrollLeft(div));
    });
    _defineProperty(this, "endAnimation", debounce(() => {
      if (this.state.mounted) this.setState({
        animationStage: 0
      });
    }, 300));
    _defineProperty(this, "onClickTab", selectedIndex => {
      this.setActiveTab(selectedIndex);
      this.props.onChangeIndex && this.props.onChangeIndex(selectedIndex);
    });
    this.state = {
      animationStage: 0,
      selectedIndex: 0,
      selectedLeft: 0,
      selectedWidth: 0,
      prevSelectedLeft: 0,
      showScrollLeft: true,
      showScrollRight: true
    };
    this.tabsRef = /*#__PURE__*/_react.default.createRef(); //we need the width of the tabs, entire bar and to control scroll manually.
    this.scrollLeftRef = /*#__PURE__*/_react.default.createRef(); //we need to know the size of the buttons
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateButtons);
    this.tabsRef.current.removeEventListener("scroll", this.updateButtons);
    // Need to know immediately in endAnimation (don't cause a render cycle)
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.mounted = false;
  }
  componentDidMount() {
    const {
      children
    } = this.props;
    window.addEventListener("resize", this.updateButtons);
    this.tabsRef.current.addEventListener("scroll", this.updateButtons);

    //work out the total width of all the tabs
    let scrollWidth = 0;
    for (var i = 0, j = this.tabsRef.current.children.length; i < j; i++) {
      scrollWidth += this.tabsRef.current.children[i].offsetWidth;
    }
    let selectedIndex = this.props.index;
    if (selectedIndex === undefined) {
      //work out which tab should start selected
      var selectedKids = _react.default.Children.map(children, (child, index) => {
        if (child.type === _Tab.Tab && child.props.selected) {
          return index;
        }
      });
      selectedIndex = selectedKids && selectedKids.length && selectedKids[0] || 0;
    }
    this.setState({
      mounted: true,
      selectedIndex: selectedIndex,
      scrollWidth: scrollWidth,
      scrollButtonWidth: this.scrollLeftRef.current.offsetWidth
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      mounted
    } = this.state;
    let selectedIndex = this.state.selectedIndex;
    //being controlled from above
    if (this.props.index !== undefined && prevProps.index !== this.props.index) {
      this.setActiveTab(this.props.index);
    }
    //first mount we have to set the active tab from the selected index
    if (!prevState.mounted && mounted) {
      this.setActiveTab(selectedIndex);
    }
    //if the selected changes we have to do the scroll animation
    if (selectedIndex !== prevState.selectedIndex) {
      const selectedTab = this.tabsRef.current.children[selectedIndex];
      this.scrollTo(this.calculateScrollLeft(selectedTab));
    }
    if (prevState.animationStage !== this.state.animationStage) {
      if (this.state.animationStage === 2) this.setState({
        animationStage: 1
      });
      if (this.state.animationStage === 1) this.endAnimation();
    }
  }
  // Corresponds to 10 frames at 60 Hz.

  updateScrollButtonState(newScroll) {
    const {
      scrollButtonWidth,
      scrollWidth
    } = this.state;
    const tabList = this.tabsRef.current;
    if (newScroll === undefined) newScroll = tabList.scrollLeft;
    const tabControl = tabList.parentElement.parentElement;
    const showScrollLeft = newScroll > scrollButtonWidth;
    const showScrollRight = newScroll < scrollWidth - tabControl.offsetWidth;
    let tabsWidth = tabControl.offsetWidth;
    if (showScrollLeft) tabsWidth -= scrollButtonWidth;
    if (showScrollRight) tabsWidth -= scrollButtonWidth;
    this.setState({
      showScrollLeft: showScrollLeft,
      showScrollRight: showScrollRight,
      tabsWidth: tabsWidth,
      tabsMarginBottom: "-".concat(tabList.offsetHeight - tabList.clientHeight, "px"),
      tabsHeight: "".concat(tabList.clientHeight, "px")
    });
  }
  calculateScrollLeft(selectedTab) {
    const {
      scrollButtonWidth
    } = this.state;
    const tabList = this.tabsRef.current;
    const visibleStart = tabList.scrollLeft;
    const visibleEnd = visibleStart + tabList.offsetWidth;
    const tabLeft = selectedTab.offsetLeft;
    const tabRight = tabLeft + selectedTab.offsetWidth;
    if (tabLeft < visibleStart) {
      return tabLeft;
    } else if (tabRight > visibleEnd) {
      const start = Math.max(tabList.scrollLeft, scrollButtonWidth);
      return start - visibleEnd + tabRight;
    }
    return tabList.scrollLeft;
  }
  scrollTo(value) {
    this.updateScrollButtonState(value);
    this.tabsRef.current.scrollLeft = value;
  }
  getIndicator() {
    const {
      animationStage,
      selectedLeft,
      prevSelectedLeft,
      selectedWidth
    } = this.state;
    let left = 0;
    if (animationStage === 0) left = 0;
    //animation end
    else if (animationStage === 1) left = selectedLeft;
    //animation do
    else if (animationStage === 2) left = prevSelectedLeft; //animation start

    const indicator = /*#__PURE__*/_react.default.createElement("span", {
      className: _tabsModule.default["arc3-tabs__indicator"],
      style: {
        left: "".concat(left, "px"),
        width: "".concat(selectedWidth, "px")
      }
    });
    return indicator;
  }
  render() {
    const {
      selectedIndex,
      tabsHeight,
      tabsMarginBottom,
      tabsWidth,
      showScrollLeft,
      showScrollRight,
      scrollButtonWidth,
      animationStage
    } = this.state;
    const {
      className,
      children
    } = this.props;
    const classes = (0, _classnames.default)(_tabsModule.default["arc3-tabs"], className);
    const tabs = _react.default.Children.map(children, child => {
      return child.type === _Tab.Tab ? child : null;
    });
    if (!tabs.length) throw new Error("Tab components must be specified as children of the Tabs component");
    const enhancedTabs = _react.default.Children.map(tabs, (child, index) => {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        index,
        id: child.props.id || "tabIndex" + index,
        //used for accessability
        selected: index === selectedIndex,
        children: child.props.children,
        onClick: this.onClickTab,
        indicator: index === selectedIndex && !animationStage && this.getIndicator()
      });
    });
    const tabPanels = _react.default.Children.map(children, child => {
      return child.type === TabPanel ? child : null;
    });
    const enhancedTabPanels = _react.default.Children.map(tabPanels, (child, index) => {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        index,
        labelledBy: enhancedTabs[index].id,
        //used for accessability
        children: child.props.children,
        show: index === selectedIndex
      });
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      "data-cy": "arc3-tabs"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _tabsModule.default["arc3-tabs__scrollingTabList"],
      style: {
        height: tabsHeight
      }
    }, showScrollLeft && /*#__PURE__*/_react.default.createElement(ScrollButton, {
      direction: "left",
      handleScrollClick: this.handleScrollClick,
      buttonRef: this.scrollLeftRef
    }), showScrollRight && /*#__PURE__*/_react.default.createElement(ScrollButton, {
      direction: "right",
      handleScrollClick: this.handleScrollClick
    }), /*#__PURE__*/_react.default.createElement("div", {
      role: "tablist",
      ref: this.tabsRef,
      style: {
        marginBottom: tabsMarginBottom,
        left: showScrollLeft ? scrollButtonWidth : 0,
        width: tabsWidth
      }
    }, enhancedTabs, animationStage > 0 && this.getIndicator())), enhancedTabPanels.length > 0 && /*#__PURE__*/_react.default.createElement("div", null, enhancedTabPanels));
  }
}
exports.Tabs = Tabs;
const ScrollButton = _ref => {
  let {
    className,
    handleScrollClick,
    direction,
    buttonRef,
    ...props
  } = _ref;
  const onClick = e => {
    e.target.blur();
    handleScrollClick(e, direction);
  };
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    className: (0, _classnames.default)(_tabsModule.default["arc3-tabs__scrollButton"], _tabsModule.default[direction], className),
    onClick: onClick,
    ref: buttonRef
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "slim_arrow_" + direction
  }));
};
exports.ScrollButton = ScrollButton;
const TabPanel = _ref2 => {
  let {
    className,
    show,
    labelledBy,
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    role: "tabpanel",
    className: (0, _classnames.default)(_tabsModule.default["arc3-tabs"], className, {
      [_tabsModule.default["show"]]: show
    }),
    "aria-labelledby": labelledBy
  }, props), children);
};
exports.TabPanel = TabPanel;
Tabs.propTypes = {
  /** Optionally set the index via prop (useful for swipeable-views integration). */
  index: _propTypes.PropTypes.number,
  /** Optional event handler to call when index is changed */
  onChangeIndex: _propTypes.PropTypes.func,
  /** Custom CSS classes */
  className: _propTypes.PropTypes.string,
  children: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.arrayOf(_propTypes.PropTypes.node), _propTypes.PropTypes.node]).isRequired
};